import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upperCase',
    standalone: false
})
export class UpperCasePipe implements PipeTransform {
  transform(value: string): string {
    return value.toUpperCase();
  }
}
